var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useRef } from 'react';
import { bindActionCreators } from 'redux';
import { actions } from 'react-redux-form';
import { connect } from 'react-redux';
import { get } from 'lodash';
import { Icon } from "../../UI";
import { Translate } from "../../I18N";

import { MetadataFormFiles } from "./MetadataFormFiles";





const handlePDFUpload =
(event, model) => (dispatch) => {
  const { files } = event.target;
  if (files && files.length > 0) {
    Array.from(files).forEach((file) => {
      const data = { data: URL.createObjectURL(file), originalFile: file };
      dispatch(actions.push(`${model}.documents`, data));
    });
  }
};

const mapStateToProps = (state, ownProps) => {
  const entity = get(state, ownProps.model);
  return {
    entity
  };
};

const mapDispatchToProps = (dispatch) =>
bindActionCreators({ handlePDFUploadAction: handlePDFUpload }, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);




const PDFUpload = ({ model, entity, handlePDFUploadAction }) => {
  const inputFileRef = useRef(null);

  const handleUploadButtonClicked = () => {var _inputFileRef$current;
    (_inputFileRef$current = inputFileRef.current) === null || _inputFileRef$current === void 0 ? void 0 : _inputFileRef$current.click();
  };

  return /*#__PURE__*/(
    _jsx("div", { className: "document-list-parent" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "attachments-list-header editor" }, void 0, /*#__PURE__*/
    _jsx("h2", {}, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Primary Documents")
    ), /*#__PURE__*/
    _jsx("button", { type: "button", onClick: handleUploadButtonClicked, className: "btn" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "plus" }), "\xA0", /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Add PDF")
    )
    ), /*#__PURE__*/
    React.createElement("input", {
      "aria-label": "pdfInput",
      type: "file",
      onChange: (event) => handlePDFUploadAction(event, model),
      style: { display: 'none' },
      ref: inputFileRef,
      accept: "application/pdf",
      multiple: true }
    ), /*#__PURE__*/
    _jsx(MetadataFormFiles, { model: model, type: "document", files: entity.documents })
    ));

};

const container = connector(PDFUpload);
export { container as PDFUpload };